<template>
  <div id="app">
    <my-header></my-header>
    <router-view v-if="isRoute" />
    <my-footer></my-footer>
  </div>
</template>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>

<script>
export default {
  components: {
    myHeader: () => import('./components/tool/header.vue'),
    myFooter: () => import('./components/tool/footer.vue')
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRoute: true,
      version: 'v 1.0.5'
    }
  },
  methods: {
    reload() {
      this.isRoute = false;
      this.$nextTick(() => {
        this.isRoute = true
      })
    }
  },
  created() {
    console.log(this.version);
  },
}
</script>
